import getParentBlockByElement from 'src/js/modules/blocks/helpers/get-parent-block-by-element';
import { blocks, anodum } from '@yola/ws-sdk';

const supportedBlockIds = [
  'about-splitscreen-with-media',
  'about-splitscreen-with-overlaying-media',
  'about-with-2-media-and-testimonial',
  'about-with-features',
  'about-with-features-and-scribbles',
  'about-with-media',
  'article',
  'articles',
  'cover-with-features-and-side-media',
  'cover-with-horizontal-layout',
  'cover-with-laptop-and-phone',
  'cover-with-media',
  'cover-with-media-bg-image',
  'cover-with-numbers-and-cta',
  'cover-with-overlaying-media',
  'cover-with-overlaying-side-media',
  'cover-with-phone',
  'cover-with-phone-bg-image',
  'cover-with-plain-text-and-media-bg-image',
  'cover-with-scrolling-media',
  'cover-with-side-media',
  'cover-with-tablet',
  'cover-with-video-embed',
  'cover-with-video-embed-bg-image',
  'cta-banner-with-media',
  'custom',
  'features-with-media-and-icon',
  'gallery',
  'gallery-full-width',
  'gallery-splitscreen-with-slider',
  'media',
  'media-bg-image',
  'media-fullwidth',
  'media-with-laptop',
  'media-with-laptop-bg-image',
  'menu-with-media',
  'music-embed',
  'pricing-card-with-media',
  'product-with-media',
  'products-with-aside-media',
  'products-with-media',
  'services-with-accordion-and-side-media',
  'services-with-media',
  'services-with-media-cards',
  'services-with-media-cards-vertical-layout',
  'team-member-with-media',
  'team-members-with-aside-media',
  'team-members-with-media',
  'testimonial-with-media',
  'testimonials-with-aside-media',
  'testimonials-with-media',
  'video-embed',
  'video-embed-bg-image',
  'video-embed-with-laptop',
  'video-embed-with-laptop-bg-image',
  'widget-embed',
  'widget-gallery',
  'widget-image',
  'widget-music',
  'widget-video',
];

const restrictedParentsSelector = '.ws-m-blockquote__author';

const isMedia = (element) => {
  if (!element) return false;

  if (anodum.isTag(element, 'ws-media-container') || anodum.isTag(element, 'ws-composite-group')) {
    const closestBlock = getParentBlockByElement(element);
    const blockId = blocks.accessors.getBlockIdByElement(closestBlock);
    return supportedBlockIds.includes(blockId) && !element.closest(restrictedParentsSelector);
  }

  return false;
};

export default isMedia;
